import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnAlternative, BtnPrimary } from "../../share/buttons/Btn";
import MessageQuill from "../Message/MessageQuill";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import useFetch from "../../../Hooks/useFetch";
import moment from "jalali-moment";
import { useCreate } from "../../../Context/CreateContext";
import { Modal } from "../../share/modal/Modal";
import DragAndDropCourse from "./DragAndDropCourse";

const AddHomeworkCourse = ({ close, id, setId, sessionInfo, homework }) => {
    //const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [call, setCall] = useState();
    const [uploadCall, setUploadCall] = useState();
    const [file, setFile] = useState();
    const [uploadedHomeWorks, setUploadedHomeWorks] = useState();
    const [description, setDescription] = useState();
    const [upload, setUpload] = useState(false);
    const [sessionHomework, setSessionHomework] = useState({
        id: "",
        session_name: "",
        session_start_time: "",
        session_end_time: "",
        session_description: "",
    });

    const handleModalClose = (e) => {
        e.stopPropagation();
        close(false);
        setSessionHomework({
            id: "",
            session_name: "",
            session_start_time: "",
            session_end_time: "",
            session_description: "",
        });
        setUploadedHomeWorks();
        setStart("");
        setEnd("");
        setId("");
    };

    const handleModal = () => {
        setUpload(!upload);
    };

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        setSessionHomework({
            ...sessionHomework,
            session_start_time: moment(
                start,
                "HH:mm:ss jYYYY/jMM/jDD"
            ).format(),
        });
    }, [start]);

    useEffect(() => {
        setSessionHomework({
            ...sessionHomework,
            session_end_time: moment(end, "HH:mm:ss jYYYY/jMM/jDD").format(),
        });
    }, [end]);

    useEffect(() => {
        setSessionHomework({
            ...sessionHomework,
            session_description: description,
        });
    }, [description]);

    const submitForm = () => {
        if (id) {
            if (file) {
                const fileData = new FormData();
                fileData.append("bootcamp_session_homework", id);
                fileData.append("file", file[0]);
                setUploadCall(fileData);
                uploadHomeworkFile.reFetch();
            }

            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", 11);
            //TODO : id bootcamp dynamic she
            formData.append("session_name", sessionHomework.session_name);
            formData.append(
                "session_start_time",
                sessionHomework.session_start_time
            );
            formData.append(
                "session_end_time",
                sessionHomework.session_end_time
            );
            formData.append("session_description", description);

            setCall(formData);

            setSessionHomework({
                id: "",
                session_name: "",
                session_start_time: "",
                session_end_time: "",
                session_description: "",
            });

            setStart();
            setEnd();

            close();
        }
    };

    useEffect(() => {
        if (id) {
            setStart(
                moment(sessionHomework.session_start_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );

            setEnd(
                moment(sessionHomework.session_end_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        }
    }, [sessionHomework]);

    // const getSessionsId = useFetch({
    //     method: "GET",
    //     url: `BootCampSessionService/${id}`,
    //     noHeader: false,
    //     trigger: false,
    //     setter: setSessionHomework,
    // });

    const getSessionHomeWorks = useFetch({
        method: "GET",
        url: `BootCampSessionHomeWorkService/${id}/session_homeworks`,
        noHeader: false,
        trigger: false,
        setter: setUploadedHomeWorks,
    });

    const uploadHomeworkFile = useFetch({
        method: "POST",
        url: `BootCampSessionHomeWorkFilesService`,
        noHeader: false,
        trigger: false,
        data: uploadCall,
    });

    useEffect(() => {
        if (id && homework) {
            console.log("running");
            getSessionHomeWorks.reFetch();
        }
    }, [id]);

    return (
        <div className="AddnewsupportTicket relative max-w-3xl">
            <button
                onClick={handleModalClose}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                اطلاعات تکلیف
            </h3>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    value={sessionHomework.session_name}
                    onChange={(e) =>
                        setSessionHomework({ session_name: e.target.value })
                    }
                    type="text"
                    name="name"
                    control={control}
                    placeholder="نام تکلیف*"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                />
                <div className="flex justify-around gap-8 mb-[1.6rem]">
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        defaultValue={start}
                        setDate={setStart}
                        message="زمان شروع جلسه را وارد کنید"
                        placeholder={"زمان شروع تکلیف"}
                        full={true}
                        name="catch_start_date"
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        defaultValue={end}
                        setDate={setEnd}
                        message={"زمان پایان را وارد کنید"}
                        placeholder={"زمان پایان تکلیف"}
                        full={true}
                        name="catch_end_date"
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                </div>

                <MessageQuill
                    placeholder="توضیحات *"
                    value={sessionHomework.session_description}
                    setValue={setDescription}
                />

                <div className="flex justify-center ">
                    <div
                        className=" w-1/2 py-[15px] px-[25px] flex border-gray border-[1px] text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] justify-between cursor-pointer"
                        onClick={() => {
                            setUpload(!upload);
                            getSessionHomeWorks.reFetch();
                        }}
                    >
                        <span>بارگزاری فایل</span>
                        <Upload />
                    </div>
                    <BtnPrimary
                        className=" py-[2rem] px-[6rem] flex justify-center items-center mr-auto "
                        text={`ثبت تکلیف`}
                    />
                </div>
            </form>
            {/* {uploadedHomeWorks?.results.length !== 0 && (
                <div className="mt-10 max-w-3xl">
                    <h3 className="text-3xl mb-10">تکالیف آپلود شده :</h3>
                    <div className="flex flex-col text-2xl justify-start gap-y-8 mb-[1.6rem]">
                        {uploadedHomeWorks?.results.map(() => (
                            <div>sessionHomework File Test</div>
                        ))}
                    </div>
                </div>
            )} */}

            <Modal show={upload} closeModal={handleModal}>
                <DragAndDropCourse
                    uploadFile
                    sessions
                    sessionInfo={sessionInfo}
                    uploadedFiles={uploadedHomeWorks}
                    setFile={setFile}
                    close={handleModal}
                    label=""
                    {...register("photo", { required: false })}
                    //message="رزومه خود را انتخاب کنید"
                    error={errors["photo"]}
                    accept=".png , .jpg, .mp4, .pdf, .mp3, .docx"
                    //id="cover_upload"
                    type="image"
                />
            </Modal>
        </div>
    );
};

export default AddHomeworkCourse;
